/* istanbul ignore file */

import WebviewHandler from './WebviewHandler';

export default WebviewHandler;
